import React from 'react';
import './App.css';
import Navbar from './components/NavBar/Navbar';
import APropos from './components/APropos/APropos';
import ChildcareServices from './components/ChildcareServices/ChildcareServices';
import CMG from './components/CMG/CMG';
import LongTermContract from './components/LongTermContract/LongTermContract';
import Footer from './components/Footer/Footer';
import BackupService from './components/BackupService/BackupService';
import CookieBanner from './components/CookieBanner/CookieBanner';

function App() {
  return (
    <div className="App">
      <Navbar />
      <APropos />
      <ChildcareServices />
      <LongTermContract />
      <CMG />
      <BackupService />
      <Footer />
      <CookieBanner />
      <main>
        
        
        
      </main>
    </div>
  );
}

export default App;
